'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { attachSubComponents } from '../../util';
import { SimpleCardContext } from './SimpleCardContext';
import { CheckboxContainer, CheckmarkIcon, StyledCard } from './elements';
import { Image } from '../SimpleBlock/Image';
import { ImageTag } from '../SimpleBlock/ImageTag';
import { StateLayer, ToggleCore } from '../../core-components';
export const SimpleCardComponents = {
  Image,
  ImageTag
};
export const SimpleCard = attachSubComponents('SimpleCard', ({
  id,
  imagePosition = 'top',
  variant = 'flat',
  children,
  as,
  width,
  height,
  checked,
  onChange,
  ...props
}) => {
  const baseElement = getBaseElement(as, !!props.href, !!props.onClick, variant === 'checkbox' || variant === 'radio');
  children = variant === 'radio' || variant === 'checkbox' ? /*#__PURE__*/React.createElement(ToggleCore, {
    id: id && `${id}-toggle`,
    toggleType: variant,
    checked: checked,
    onChange: onChange,
    isToggleShowing: false
  }, children) : children;
  return /*#__PURE__*/React.createElement(SimpleCardContext.Provider, {
    value: {
      isInsideCard: true,
      imagePosition
    }
  }, /*#__PURE__*/React.createElement(StyledCard, _extends({
    $imagePosition: imagePosition,
    $variant: variant,
    $isInteractive: baseElement !== 'div',
    $isSelected: (variant === 'radio' || variant === 'checkbox') && checked,
    $width: width,
    $height: height,
    id: id,
    as: baseElement
  }, props, {
    "data-aui": "simple-card"
  }), /*#__PURE__*/React.createElement(StateLayer, null), /*#__PURE__*/React.createElement(CheckboxContainer, {
    $isChecked: checked
  }, /*#__PURE__*/React.createElement(CheckmarkIcon, {
    src: "checkmark-v",
    fill: "white"
  })), children));
}, {
  ...SimpleCardComponents
});
function getBaseElement(userAs, hasHref, hasOnClick, isInput) {
  if (userAs) {
    return userAs;
  } else if (isInput) {
    return 'label';
  } else if (hasHref) {
    return 'a';
  } else if (hasOnClick) {
    return 'button';
  } else return 'div';
}